import {
  FragmentScreenViewDTO,
  IFragmentFragmentScreenDTO,
} from 'business/models/Models';
import FragmentService from 'business/services/FragmentService';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React, { useEffect, useState } from 'react';

interface Props {
  fragmentFragmentScreen: IFragmentFragmentScreenDTO[];
  fragmentVolume?: number;
}

const fragmentService = new FragmentService();
export const FragmentInfo = (props: Props) => {
  const { fragmentFragmentScreen, fragmentVolume } = props;
  const [fragments, setFragments] = useState<FragmentScreenViewDTO[]>([]);
  useEffect(() => {
    const fetchFragmentInfo = async () => {
      fragmentService.getFragmentsInfo(fragmentFragmentScreen).then((res) => {
        setFragments(res);
      });
    };
    if (fragmentFragmentScreen?.length) {
      fetchFragmentInfo();
    }
  }, [fragmentFragmentScreen]);

  return (
    <>
      {fragments.map((fragment) => {
        return (
          <div
            id={`fragmentinfo-fragmentcard-${fragment.fragmentFragmentScreenId}`}
            key={'fragment_card' + fragment.fragmentFragmentScreenId}
            className="proteininfo ingredientInfoProteinContent flex w-full"
          >
            <div
              id={`fragmentinfo-fragmentscreen-${fragment.fragmentFragmentScreenId}`}
              className="flex  flex-space-between flex-y-center"
            >
              <RMSvgIcon name="FragmentScreen" />
            </div>
            <div id={`fragmentinfo-fragment${fragment.fragmentFragmentScreenId}-wrapper`}>
              <div
                id={`fragmentinfo-fragment-${fragment.fragmentName}`}
                className="inline-block ml-2.5"
              >
                {fragment.fragmentName}
              </div>
              <div
                id={`fragmentinfo-fragment-${fragment.fragmentName}-conc-size`}
                className="ingredient-card-text ing-card-light ml-2.5"
              >
                Conc: {fragment.workingConcentration} mM, Size:{fragment.size}, Volume:
                {fragmentVolume ?? 0} µL
              </div>
              <div
                id={`fragmentinfo-fragment-${fragment.fragmentName}-notes`}
                className="ingredient-card-text ing-card-light ml-2.5"
              >
                Notes: {fragment.notes}
              </div>
            </div>
            <br />
          </div>
        );
      })}
    </>
  );
};
